import Vue from "vue";
import Vuex from "vuex";
import $http from "../api/http";
import $path from "../api/url";
import { TOKEN, USER_INFO, TIMESTAMP, USER_ID ,USER_SIGN,LOCAL_LANGUAGE} from "../api/localStorageName";
Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    token: localStorage.getItem(TOKEN),
    msgId: null, //获取验证码 msgId
    userId: localStorage.getItem(USER_ID),
    userSign: localStorage.getItem(USER_SIGN),
    userInfo: localStorage.getItem(USER_INFO)
      ? JSON.parse(localStorage.getItem(USER_INFO))
      : null // 用户基本信息
  },
  mutations: {
    login_success(state, token, userId) {
      state.token = token;
      state.userId = userId;
      state.msgId = "";
    },
    userinfo_success(state, userInfo) {
      state.userInfo = userInfo;
    },
    clear_login(state) {
      state.token = "";
      state.msgId = null;
      state.userId = "";
      state.userInfo = null;
    }
  },
  actions: {
    async login({ commit, dispatch }, params) {
      const _this = this;
      return await $http
        .post($path.login, params)
        .then(res => {
          const resMsg = {
            status: res.userId ? true : false,
            msg: !res.userId ? res.msg : res.msg,
            res:res
          };
          if (res.userId) {
            commit("login_success", res.toKen, res.userId);
            localStorage.setItem(TOKEN, res.toKen);
            localStorage.setItem(LOCAL_LANGUAGE, res.agentLang);

            localStorage.setItem(USER_ID, res.userId);
            //localStorage.setItem(USER_SIGN, res.userSign);
            localStorage.setItem('verifyState', res.verifyState);
            localStorage.setItem(TIMESTAMP, new Date().getTime());
            localStorage.setItem("change", JSON.stringify(res));
            dispatch("getUserInfo", res.userId);
          }
          return resMsg;
        })
        .catch(err => {
          /*  Message({
            showClose: true,
            message: err,
            type: "error"
          }); */
          console.error(err);
          return null;
        });
    },
    async getPhoneCode({ commit }, userName) {
      if (!userName) return;
      return await $http
        .post("/sso/security/admin/getMsgCod", {
          userName: userName
        })
        .then(res => {
          this.msgId = res.msgId || null;
          localStorage.removeItem(TOKEN);
          commit("login_success", "", "");
          const resMsg = {
            status: res.msgId ? true : false,
            msg: res.msgId ? res.msgId : res.msg
          };
          return resMsg;
        })
        .catch(err => {
          const resMsg = {
            status: false,
            msg: err
          };
          console.log(err);
          return resMsg;
        });
    },
    getUserInfo({ commit }, userId) {
      /* 获取用户基本信息 */
      $http
        .post($path.getAgentInfo, {
          agentId: userId
        })
        .then(res => {
          var token = localStorage.getItem(TOKEN);
          res.icon = $path.base + '/server-file/fastdfs/download?path=' + res.icon + '?token=' + token;
          commit("userinfo_success", res);
          console.log(res)
          console.log(res.agSign)
          localStorage.setItem(USER_INFO, JSON.stringify(res));
          localStorage.setItem(USER_SIGN, res.agSign);
        })
        .catch(err => {
          console.log(err);
        });
      ///sso/security/admin/userInfo
    },
    logout({ commit }) {
      commit("clear_login");
    }
  },
  getters: {}
});
export default store;



//////////////////
// WEBPACK FOOTER
// ./store/index.js
// module id = vdRI
// module chunks = 28